module.exports = __webpack_public_path__ + "494cd07c/img/product-icon-grey.b248963c.svg";